import { Suspense, useContext, useState, useEffect } from 'react';
import { useRouteLoaderData, Await, Navigate, Link } from "react-router-dom"
import { AuthContext } from '../store/auth-context.js'
import GroupsList from '../components/GroupsList.jsx'
import MatchesList from '../components/MatchesList.jsx';
import Standings from '../components/Standings.jsx';
import CurrentUserPoints from '../components/CurrentUserPoints.jsx';
import SelectGroup from '../components/select-group/SelectGroup.jsx';
import { ListGroups } from '../repo/GroupsRepo.js';
import TournamentInfo from '../components/TournamentInfo.jsx';
import TournamentInfoMatches from '../components/TournamentInfoMatches.jsx';

export default function HomePage() {
  const { token, isAuthenticated } = useContext(AuthContext)
  const {groups, groupId, matchesPage, tournament, tournamentInfo} = useRouteLoaderData('home-page')

  const [currentGroupId, setCurrentGroupId] = useState(groupId)
  const [currentTournament, setCurrentTournament] = useState(tournament)
  const [currentMatchesPage, setCurrentMatchesPage] = useState(matchesPage || 1)
  const [showTournamentInfo, setShowTournamentInfo] = useState(tournamentInfo)

  useEffect(() => {
    const handleResize = () => {
      try {
        const mainDiv = document.getElementById("main-divs");
        if (window.innerWidth >= 1024) {
          for (const child of mainDiv.children) {
            child.classList.remove("hidden");
          }
        } else {
          for (let i = 0; i < mainDiv.children.length; i++) {
            if (i === 0 || window.innerWidth <= 700) continue; // Skip the first child or if screen is already too small
            mainDiv.children[i].classList.add("hidden");
          }
        }
      } catch (error) {
      }
    };

    try {
      handleTabClick("matches");
    } catch (error) {
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleShowTournamentInfo = (event) => {
    event?.preventDefault()
    setShowTournamentInfo(true)
    window.history.replaceState(null, "Bolão da Copa - Detalhes do Torneio", "?group_id=" + currentGroupId + "&tournament_info=1")
  }

  const handleHideTournamentInfo = (event) => {
    event?.preventDefault()
    setShowTournamentInfo(false)
    window.history.replaceState(null, "Bolão da Copa", "?group_id=" + currentGroupId)
  }

  const handleGroupClick = (event) => {
    const groupId = event.target.value;
    const group = groups.find((g) => g.group_id === groupId)

    setCurrentGroupId(groupId)
    setCurrentMatchesPage(1)
    setShowTournamentInfo(false)
    setCurrentTournament({ id: group?.tournament_id, name: group?.tournament_name + " " + group?.tournament_edition })

    window.history.replaceState(null, "Bolão", "?group_id=" + groupId + "&matches_page=1")
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign_in" replace />;
  }

  const handleTabClick = (suffixID) => {
    if (window.innerWidth >= 1024) return null;

    try {
      const tabID = suffixID + "-tab"
      const divID = suffixID + "-div"
      const mainDiv = document.getElementById("main-divs");
      const mainTab = document.getElementById("main-tabs");

      for (const child of mainDiv.children) {
        if (child.id === divID) {
          child.classList.remove("hidden");
        } else {
          child.classList.add("hidden");
        }
      }

      for (const child of mainTab.children) {
        if (child.id === tabID) {
          child.classList.remove("bg-white");
          child.classList.add("bg-slate-100");
          child.classList.remove("hover:bg-slate-100");
          child.classList.remove("hover:underline");
          child.classList.add("font-bold");
        } else {
          child.classList.remove("bg-slate-100");
          child.classList.add("bg-white");
          child.classList.add("hover:bg-slate-100");
          child.classList.add("hover:underline");
          child.classList.remove("font-bold");
        }
      }
    } catch (error) {
    }
}

  return(
    <section className='pb-10'>
      <div className='hidden'>
        <div className='text-green-500'>Text Green 500</div>
        <div className='text-yellow-500'>Text Yellow 500</div>
        <div className='text-orange-500'>Text Orange 500</div>
        <div className='text-purple-500'>Text Purple 500</div>
        <div className='text-black'>Text Black</div>
        <div className='bg-green-500'>Text Green 500</div>
        <div className='bg-yellow-500'>Text Yellow 500</div>
        <div className='bg-orange-500'>Text Orange 500</div>
        <div className='bg-purple-500'>Text Purple 500</div>
        <div className='bg-black text-white'>BG Black</div>
      </div>
      {token && (
      <div className="container mx-auto flex flex-col items-center justify-between lg:w-6xl ">
        <div className='flex flex-col w-full'>
          <div className={`flex flex-col ${ currentGroupId ? 'lg:flex-row' : ''} bg-slate-100 rounded-lg lg:mt-4 mx-4 mb-4`}>

            <div id="groups" className={`w-full ${ currentGroupId ? 'lg:w-1/2' : 'pt-4'}`}>
              <Suspense fallback={<p>Carregando...</p>}>
                <Await resolve={groups}>
                  {(loadedGroups) => <GroupsList groups={loadedGroups} selectedOption={currentGroupId} groupOnClick={handleGroupClick} />}
                </Await>
              </Suspense>
            </div>

            {!currentGroupId && (
              <SelectGroup groups={groups} />
            )}

            <div id="current-user-points" className={`w-full ${ currentGroupId ? 'lg:w-1/2' : ''}`}>
              <Suspense fallback={<p>Carregando...</p>}>
                <CurrentUserPoints key={"current-user-points|" + currentGroupId} groupId={currentGroupId} />
              </Suspense>
            </div>
          </div>
        </div>

        {currentGroupId && currentTournament &&
        <div id="tournament-div" className='flex flex-col w-full'>
          <div id="tournament-tab" className='ml-2 mr-2 pr-8 flex flex-row lg:flex-row justify-between w-full'>
            <div className="w-full mb-4 p-1 bg-slate-50 rounded-lg">
              <h2 className="text-xl font-bold mb-2 text-center">{ currentTournament.name }</h2>
              <div className="text-center mb-2">
                {!showTournamentInfo && currentGroupId && (
                  <Link onClick={handleShowTournamentInfo} className="text-green-600 underline hover:no-underline text-sm">ver detalhes do torneio</Link>
                )}
                {showTournamentInfo && (
                  <Link onClick={handleHideTournamentInfo} className="text-green-600 underline hover:no-underline text-sm">voltar para o Bolão</Link>
                )}
              </div>
              {currentGroupId && currentTournament && showTournamentInfo && (
                <div className="w-full p-2">
                  <TournamentInfo groupId={currentGroupId} tournamentId={currentTournament.id} onBack={handleHideTournamentInfo} />
                </div>
              )}
            </div>
          </div>
        </div>
        }

        {currentGroupId && !showTournamentInfo &&
        <div id="group-div" className='flex flex-col w-full'>
          <div id="main-tabs" className='lg:hidden ml-4 mr-4 pr-8 flex flex-row lg:flex-row justify-between w-full'>
            <div id="matches-tab" className='w-1/2 text-center mr-1 rounded-t-lg bg-slate-100 font-bold'>
              <Link onClick={() => handleTabClick("matches")} className='block p-2'>Palpites</Link>
            </div>
            <div id="standings-tab" className='w-1/2 text-center ml-1 rounded-t-lg'>
              <Link onClick={() => handleTabClick("standings")} className='block p-2'>Ranking</Link>
            </div>
          </div>

          <div id="main-divs" className='flex flex-col lg:flex-row justify-between w-full'>
            <div id="matches-div" className='ml-4 mr-4 lg:mr-0 bg-slate-100 pt-4 lg:rounded-lg lg:mt-0 lg:w-3/5 pb-4'>
              <h1 className='hidden lg:block mb-4 w-full text-center text-xl font-bold'>Palpites</h1>
              <Suspense fallback={<p>Carregando...</p>}>
                <MatchesList key={currentGroupId} groupId={currentGroupId} matchesPage={currentMatchesPage} />
              </Suspense>
            </div>

            <div id="standings-div" className='ml-4 mr-4 bg-slate-100 pt-4 lg:rounded-lg lg:mt-0 lg:w-2/5 pb-4'>
              <h1 className='hidden lg:block mb-4 w-full text-center text-xl font-bold'>Ranking</h1>
              <Suspense fallback={<p>Carregando...</p>}>
                <Standings key={"standings-" + currentGroupId} groupId={currentGroupId} />
              </Suspense>
            </div>
          </div>
        </div>
        }
      </div>
      )}
      {!token && (
        ""
      )}
    </section>
  )
}

export async function loader({ params, request }) {
  const searchParams = new URL(request.url).searchParams;

  const groups = (await ListGroups(null, true)).data;

  let groupId = null
  if (groups.length === 1) {
    groupId = groups[0].group_id;
  } else {
    groupId = searchParams.get("group_id")
  }

  const group = groups.find((g) => g.group_id === groupId)

  return {
    groups: groups,
    groupId: groupId,
    matchesPage: searchParams.get("matches_page"),
    tournament: { id: group?.tournament_id, name: group?.tournament_name + " " + group?.tournament_edition },
    tournamentInfo: searchParams.get("tournament_info") !== null
  }
}
